import React, { useEffect, useRef, useState } from 'react'
import styles from './WrestlerSmallView.module.scss'
import {
  DesktopBodyLarge,
  DesktopBodyMedium,
  DesktopButton,
  DesktopTitleLarge,
} from '../../Typography'
import { URLS } from '../../content/urls'

interface WrestlerSmallViewProps {
  profilbild: string
  name: string
  onClick: () => void
  title?: string | null
  bigFont?: boolean
}

export const WrestlerSmallView: React.FC<WrestlerSmallViewProps> = ({
  profilbild,
  name,
  onClick,
  title = null,
  bigFont = false,
}) => {
  const nameRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)
  const [fontSize, setFontSize] = useState(bigFont ? 1.5 : 1)
  const [titleFontSize, setTitleFontSize] = useState(1)

  useEffect(() => {
    const adjustFontSize = (
      ref: React.RefObject<HTMLDivElement>,
      setFont: (size: number) => void,
      initialSize: number,
    ): void => {
      if (ref.current) {
        const parentWidth = ref.current.parentElement?.offsetWidth || 0
        let newFontSize = initialSize
        const minFontSize = 0.7

        while (ref.current.scrollWidth > parentWidth - 16 && newFontSize > minFontSize) {
          newFontSize -= 0.05
          ref.current.style.fontSize = `${newFontSize}rem`
          setFont(newFontSize)
        }
      }
    }

    adjustFontSize(nameRef, setFontSize, bigFont ? 1.5 : 1)
    adjustFontSize(titleRef, setTitleFontSize, 1)

    window.addEventListener('resize', () => {
      adjustFontSize(nameRef, setFontSize, bigFont ? 1.5 : 1)
      adjustFontSize(titleRef, setTitleFontSize, 1)
    })

    return () => {
      window.removeEventListener('resize', () => {
        adjustFontSize(nameRef, setFontSize, bigFont ? 1.5 : 1)
        adjustFontSize(titleRef, setTitleFontSize, 1)
      })
    }
  }, [name, title, bigFont])

  return (
    <div className={styles.container} onClick={onClick}>
      <div className={styles.backgroundBox}>
        <img
          src={profilbild !== '' ? profilbild : URLS.vakantWrestlerImage}
          alt={'Foto von ' + name}
        />
        <div className={styles.nameBand}>
          <div className={styles.nameBandContent}>
            {bigFont ? (
              <>
                <DesktopTitleLarge fontSize={fontSize} darkFont={true} ref={nameRef}>
                  {name.toUpperCase()}
                </DesktopTitleLarge>
                {title && (
                  <DesktopBodyLarge
                    darkFont={true}
                    fontWeight={600}
                    fontSize={titleFontSize}
                    ref={titleRef}
                  >
                    {title}
                  </DesktopBodyLarge>
                )}
              </>
            ) : (
              <>
                <DesktopButton fontSize={fontSize} darkFont={true} ref={nameRef}>
                  {name.toUpperCase()}
                </DesktopButton>
                {title && (
                  <DesktopBodyMedium darkFont={true} fontSize={titleFontSize} ref={titleRef}>
                    {title}
                  </DesktopBodyMedium>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
